import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 20l1.3 -3.9a9 8 0 1 1 3.4 2.9l-4.7 1","key":"svg-0"}],["path",{"d":"M8 13l3 -2l2 2l3 -2","key":"svg-1"}]]

/**
 * IconBrandMessenger
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYnJhbmQtbWVzc2VuZ2VyIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDIwbDEuMyAtMy45YTkgOCAwIDEgMSAzLjQgMi45bC00LjcgMSIgLz4KICA8cGF0aCBkPSJNOCAxM2wzIC0ybDIgMmwzIC0yIiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/brand-messenger
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBrandMessenger = createReactComponent('outline', 'brand-messenger', 'BrandMessenger', __iconNode);

export default IconBrandMessenger;